import type { NestedTreeLocale } from "@/locales/fr/nested-tree";

const nestedTreeLocale: NestedTreeLocale = {
  nestedTree: {
    searchPlaceholder: "Search",
    clearSearchAriaLabel: "Clear",
    emptyMessage: "No matches",
  },
};

export default nestedTreeLocale;
